// Admin Home Tab Component
// Main admin home page with sub-tabs for different admin features
// Currently has Featured Content sub-tab, scalable for future features

import React, { useState } from 'react';
import { FeaturedContentManager } from './FeaturedContentManager';
import './AdminHomeTab.css';

export function AdminHomeTab() {
  const [activeSubTab, setActiveSubTab] = useState('featured-content');

  // Sub-tabs for scalability - easy to add more admin features
  const subTabs = [
    { id: 'featured-content', label: 'Featured Content', icon: 'fa-star' }
    // Future sub-tabs can be added here:
    // { id: 'analytics', label: 'Analytics', icon: 'fa-chart-bar' },
    // { id: 'settings', label: 'Settings', icon: 'fa-cog' },
  ];

  const renderSubTabContent = () => {
    switch (activeSubTab) {
      case 'featured-content':
        return <FeaturedContentManager />;
      default:
        return (
          <div className="admin-placeholder">
            <i className="fa-solid fa-tools admin-placeholder-icon"></i>
            <h3>Feature Coming Soon</h3>
            <p>This admin feature is under development.</p>
          </div>
        );
    }
  };

  return (
    <div className="admin-tab-content">
      <div className="admin-section-header">
        <h2>Learn Admin Home</h2>
        <p>Manage featured content and learn section settings.</p>
      </div>

      {/* Sub-tab navigation */}
      <div className="admin-sub-tabs-nav">
        {subTabs.map((tab) => (
          <button
            key={tab.id}
            className={`admin-sub-tab-btn ${activeSubTab === tab.id ? 'active' : ''}`}
            onClick={() => setActiveSubTab(tab.id)}
          >
            <i className={`fa-solid ${tab.icon}`}></i>
            <span>{tab.label}</span>
          </button>
        ))}
      </div>

      {/* Sub-tab content */}
      <div className="admin-sub-tab-content">
        {renderSubTabContent()}
      </div>
    </div>
  );
}